import React from 'react';
import { Badge } from '@/components/ui';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export function AgroRatesTable() {
  const data = [
    { id: 'AGR-PHC-001', name: 'Phân bò hoai mục', unit: 'Bao', category: 'Phân hữu cơ', budget: 35000, actual: 38000, variance: 8.5, updated: '14/05/2026' },
    { id: 'AGR-PVC-001', name: 'NPK 16-16-8', unit: 'Kg', category: 'Phân vô cơ', budget: 18000, actual: 18000, variance: 0, updated: '10/05/2026' },
    { id: 'AGR-PVS-002', name: 'Nấm đối kháng Trichoderma', unit: 'Gói', category: 'Phân vi sinh', budget: 45000, actual: 40000, variance: -11.1, updated: '01/05/2026' },
    { id: 'AGR-PVC-003', name: 'Ure 46%', unit: 'Kg', category: 'Phân vô cơ', budget: 12000, actual: 14500, variance: 20.8, updated: '12/05/2026' },
    { id: 'AGR-PHC-003', name: 'Phân trùn quế nguyên chất', unit: 'Bao', category: 'Phân hữu cơ', budget: 150000, actual: 145000, variance: -3.3, updated: '05/05/2026' }
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 border-b border-slate-200 text-slate-500 font-medium text-xs uppercase tracking-wider">
            <tr>
              <th className="px-4 py-3">Mã & Tên vật tư</th>
              <th className="px-4 py-3">Danh mục</th>
              <th className="px-4 py-3">ĐVT</th>
              <th className="px-4 py-3 text-right">Giá dự toán</th>
              <th className="px-4 py-3 text-right">Giá thực tế</th>
              <th className="px-4 py-3 text-center">Biến động</th>
              <th className="px-4 py-3 text-right">Cập nhật</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data.map((row) => (
              <tr key={row.id} className="hover:bg-slate-50/50 cursor-pointer transition-colors group">
                <td className="px-4 py-3">
                  <div className="font-medium text-slate-900">{row.name}</div>
                  <div className="text-[10px] text-slate-500 font-mono mt-0.5">{row.id}</div>
                </td>
                <td className="px-4 py-3 text-slate-600">
                   <Badge variant="outline" className="bg-slate-50 text-slate-600 font-medium">
                      {row.category}
                   </Badge>
                </td>
                <td className="px-4 py-3 text-slate-600">{row.unit}</td>
                <td className="px-4 py-3 text-right font-medium text-slate-900">
                  {row.budget.toLocaleString('vi-VN')} ₫
                </td>
                <td className="px-4 py-3 text-right font-medium text-slate-900">
                  {row.actual.toLocaleString('vi-VN')} ₫
                </td>
                <td className="px-4 py-3 text-center">
                  {row.variance > 0 ? (
                    <Badge variant="custom" className="bg-red-50 text-red-700 border-red-200 inline-flex items-center gap-1 font-medium">
                      <TrendingUp className="w-3 h-3" />
                      +{row.variance}%
                    </Badge>
                  ) : row.variance < 0 ? (
                    <Badge variant="custom" className="bg-emerald-50 text-emerald-700 border-emerald-200 inline-flex items-center gap-1 font-medium">
                      <TrendingDown className="w-3 h-3" />
                      {row.variance}%
                    </Badge>
                  ) : (
                    <Badge variant="custom" className="bg-slate-100 text-slate-600 border-slate-200 inline-flex items-center gap-1 font-medium">
                      <Minus className="w-3 h-3" />
                      0%
                    </Badge>
                  )}
                </td>
                <td className="px-4 py-3 text-xs text-slate-500 text-right">{row.updated}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
